module.exports = __webpack_public_path__ + "img/denmark-transport-accidents-male.7bb4d300.png";